import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
  footer.footer2 {
    background: ${colors.bg1} no-repeat center/cover;
    position: relative;
    padding: 4.5rem 0 5rem;

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      background: ${colors.bg1};
      opacity: 0.96;
    }

    /* Footer logo + contact info */
    .footer-logo-info {
      margin-bottom: 2rem;

      img {
        max-width: 100%;
        margin-bottom: 1.5rem;
      }

      p,
      li {
        // font-size: 0.9rem;
        color: ${colors.text3};
        line-height: 1.8;
        margin-bottom: 0.75rem;
      }

      li i {
        font-size: 1.1rem;
        color: ${colors.green};
        margin-right: 0.5rem;
      }
    }

    /* Useful links */
    .f-links {
      padding-left: 1.5rem;
      margin-bottom: 2rem;

      h5 {
        color: ${colors.border1};
        text-transform: uppercase;
        margin-bottom: 1.5rem;
        font-size: 1rem;
      }

      ul li a {
        display: flex;
        align-items: center;
        font-size: 0.9rem;
        color: ${colors.text3};
        line-height: 2;
        transition: color 0.2s ease;

        i {
          font-size: 0.75rem;
          color: ${colors.green};
          margin-right: 0.5rem;
        }

        &:hover,
        &:focus {
          color: ${colors.green};
        }
      }
    }

    /* Newsletter */
    .f-newsletter {
      margin-bottom: 2rem;

      h5 {
        color: ${colors.border1};
        text-transform: uppercase;
        margin-bottom: 1rem;
      }

      p {
        font-size: 0.9rem;
        color: ${colors.text3};
        margin-bottom: 1.5rem;
      }

      form {
        display: flex;
        gap: 0.5rem;

        input {
          flex: 1;
          padding: 0.6rem 0.75rem;
          border: 1px solid ${colors.text2};
          border-radius: 5px;
          background: transparent;
          color: ${colors.border1};
          font-size: 0.9rem;

          &::placeholder {
            color: ${colors.text3};
            font-style: italic;
          }

          &:focus {
            outline: none;
            border-color: ${colors.green};
          }
        }

        button {
          padding: 0.6rem 1.2rem;
          border-radius: 5px;
          border: none;
          font-size: 0.9rem;
          font-weight: 600;
          background: ${colors.gr_bg};
          color: ${colors.border1};
          cursor: pointer;
          transition: background 0.3s ease, transform 0.2s ease;

          &:hover,
          &:focus {
            background: ${colors.gr_bg2};
            transform: translateY(-2px);
          }
        }
      }
    }

    /* Copy + social */
    .copytext-area {
      border-top: 1px solid ${colors.black2};
      padding-top: 2rem;
      margin-top: 2rem;
      text-align: center;

      p {
        font-size: 0.85rem;
        color: ${colors.text3};
        margin-bottom: 1rem;

        a {
          color: ${colors.green};
          &:hover,
          &:focus {
            text-decoration: underline;
          }
        }
      }

      ul.social {
        display: flex;
        justify-content: center;
        gap: 0.75rem;

        li a {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          color: #fff;
          font-size: 0.9rem;
          transition: background 0.2s ease, transform 0.2s ease;

          &:hover,
          &:focus {
            transform: scale(1.1);
          }
        }

        /* Brand colors */
        li:nth-child(1) a {
          background: #4267b2;
        }
        li:nth-child(2) a {
          background: #1da1f2;
        }
        li:nth-child(3) a {
          background: #e4405f;
        }
        li:nth-child(4) a {
          background: #dd1343;
        }
        li:nth-child(5) a {
          background: #2867b2;
        }
      }
    }

    @media (max-width: 767px) {
      padding: 3rem 0;
      .f-links,
      .f-newsletter,
      .footer-logo-info {
        padding-left: 0;
      }
    }
  }
`;
